import type { ThemeItem } from '../../../core/domain'

export const ROCKROLL_ITEMS: ThemeItem[] = [
  {
    name: 'Johnny B. Goode – Chuck Berry',
    imageUrl: null,
    fact: 'Written in 1958, it defined rock & roll guitar and was sent into space on the Voyager Golden Record.'
  },
  {
    name: 'Rock Around the Clock – Bill Haley',
    imageUrl: null,
    fact: 'The 1955 #1 hit that introduced millions of teenagers worldwide to rock & roll for the very first time.'
  },
  {
    name: 'Hound Dog – Elvis Presley',
    imageUrl: null,
    fact: "Elvis's 1956 double A-side smash spent 11 weeks at #1 and shocked America with his TV hip-swivelling."
  },
  {
    name: 'Good Vibrations – The Beach Boys',
    imageUrl: null,
    fact: "Called a 'pocket symphony'; Brian Wilson spent 6 months and $16,000 creating this 1966 psychedelic masterpiece."
  },
  {
    name: 'Satisfaction – The Rolling Stones',
    imageUrl: null,
    fact: "Keith Richards dreamed the riff in 1965; it became the Stones' first US #1 and a defining anthem of the decade."
  },
  {
    name: 'Hey Jude – The Beatles',
    imageUrl: null,
    fact: "Paul McCartney wrote it for John's son Julian in 1968; at 7 minutes it was the longest UK #1 single at the time."
  },
  {
    name: 'A Day in the Life – The Beatles',
    imageUrl: null,
    fact: "The closing track of Sgt. Pepper's (1967); its final 40-note orchestral crescendo was unlike anything in pop."
  },
  {
    name: 'Stairway to Heaven – Led Zeppelin',
    imageUrl: null,
    fact: 'An 8-minute epic from 1971; consistently voted the greatest rock song ever, it was never released as a single.'
  },
  {
    name: 'Bohemian Rhapsody – Queen',
    imageUrl: null,
    fact: "Freddie Mercury's 6-minute opera-rock epic from 1975; it re-entered the UK charts after Wayne's World in 1992."
  },
  {
    name: 'Purple Haze – Jimi Hendrix',
    imageUrl: null,
    fact: "Hendrix's 1967 debut single rewrote what a guitar could do; its opening chord is among the most iconic ever."
  },
  {
    name: 'Like a Rolling Stone – Bob Dylan',
    imageUrl: null,
    fact: 'Rolling Stone magazine ranked it the greatest song of all time; its 6-minute length shocked radio in 1965.'
  },
  {
    name: 'Born to Run – Bruce Springsteen',
    imageUrl: null,
    fact: 'The 1975 anthem of escape and hope that put Springsteen on the covers of Time and Newsweek simultaneously.'
  },
  {
    name: 'Hotel California – Eagles',
    imageUrl: null,
    fact: "The 1977 Grammy-winning song with one of rock's greatest twin-guitar solos; its dark imagery is still debated."
  },
  {
    name: 'Whole Lotta Love – Led Zeppelin',
    imageUrl: null,
    fact: "Led Zeppelin's 1969 US breakthrough; its iconic riff and psychedelic midsection influenced hard rock forever."
  },
  {
    name: 'Smoke on the Water – Deep Purple',
    imageUrl: null,
    fact: 'Written about a real 1971 casino fire; its four-note riff is the first thing millions of guitarists ever learn.'
  },
  {
    name: 'Layla – Derek & the Dominos',
    imageUrl: null,
    fact: "Eric Clapton's 1970 heartbreak masterpiece, inspired by his unrequited love for George Harrison's wife Pattie."
  },
  {
    name: 'Comfortably Numb – Pink Floyd',
    imageUrl: null,
    fact: "The emotional centrepiece of The Wall (1979); David Gilmour's second guitar solo is voted the best in rock."
  },
  {
    name: "Sweet Child O' Mine – Guns N' Roses",
    imageUrl: null,
    fact: "Guns N' Roses' only US #1; Slash's opening guitar line was written as a joke exercise before becoming iconic."
  },
  {
    name: 'Back in Black – AC/DC',
    imageUrl: null,
    fact: 'A 1980 tribute to late singer Bon Scott; its album sold 50M+ copies — the second best-selling album ever.'
  },
  {
    name: 'Paranoid – Black Sabbath',
    imageUrl: null,
    fact: "Written in under 5 minutes to fill album time in 1970; it became heavy metal's first and most essential anthem."
  },
  {
    name: 'Come as You Are – Nirvana',
    imageUrl: null,
    fact: "The second single from Nevermind (1992); its hypnotic bass line and Kurt Cobain's raw vocals defined grunge."
  },
  {
    name: 'Smells Like Teen Spirit – Nirvana',
    imageUrl: null,
    fact: "Nirvana's 1991 breakthrough sold 13M+ copies worldwide and single-handedly brought grunge into the mainstream."
  },
  {
    name: 'Under the Bridge – RHCP',
    imageUrl: null,
    fact: "Anthony Kiedis wrote it about his lonely walk through LA in 1992; it became RHCP's most beloved ballad."
  },
  {
    name: 'Paint It Black – The Rolling Stones',
    imageUrl: null,
    fact: 'The 1966 #1 featuring sitar by Brian Jones; its dark Eastern sound was unlike anything on pop radio.'
  },
  {
    name: 'Light My Fire – The Doors',
    imageUrl: null,
    fact: "Jim Morrison's 1967 breakthrough hit; its extended organ solo was trimmed for radio but the full version is iconic."
  },
  {
    name: 'Mr. Tambourine Man – Bob Dylan',
    imageUrl: null,
    fact: "Dylan's 1965 surrealist poem set to music; The Byrds' folk-rock cover launched the folk-rock genre itself."
  },
  {
    name: 'Imagine – John Lennon',
    imageUrl: null,
    fact: "Lennon's 1971 utopian anthem has sold 2M+ copies in the UK alone and is consistently voted among the best ever."
  },
  {
    name: 'Let It Be – The Beatles',
    imageUrl: null,
    fact: "Paul McCartney's 1970 gospel-tinged farewell as the Beatles dissolved; inspired by a dream of his late mother."
  },
  {
    name: 'Yesterday – The Beatles',
    imageUrl: null,
    fact: 'The most covered song in history with 2,200+ versions recorded; McCartney woke up with the melody fully formed.'
  },
  {
    name: 'Blackbird – The Beatles',
    imageUrl: null,
    fact: "Written during the 1968 US civil rights crisis; McCartney's fingerpicked acoustic gem endures as a timeless classic."
  },
  { name: 'Come Together – The Beatles', imageUrl: null },
  { name: 'While My Guitar Gently Weeps – The Beatles', imageUrl: null },
  { name: 'Twist and Shout – The Beatles', imageUrl: null },
  { name: "I Want You (She's So Heavy) – The Beatles", imageUrl: null },
  { name: 'Kashmir – Led Zeppelin', imageUrl: null },
  { name: 'Black Dog – Led Zeppelin', imageUrl: null },
  { name: 'Rock and Roll – Led Zeppelin', imageUrl: null },
  { name: 'Immigrant Song – Led Zeppelin', imageUrl: null },
  { name: "Since I've Been Loving You – LZ", imageUrl: null },
  { name: 'Communication Breakdown – LZ', imageUrl: null },
  { name: 'Gimme Shelter – Rolling Stones', imageUrl: null },
  { name: 'Wild Horses – Rolling Stones', imageUrl: null },
  { name: 'Start Me Up – Rolling Stones', imageUrl: null },
  { name: 'Brown Sugar – Rolling Stones', imageUrl: null },
  { name: "Jumpin' Jack Flash – Rolling Stones", imageUrl: null },
  { name: 'Miss You – Rolling Stones', imageUrl: null },
  { name: 'Sympathy for the Devil – Rolling Stones', imageUrl: null },
  { name: 'Under My Thumb – Rolling Stones', imageUrl: null },
  { name: 'We Will Rock You – Queen', imageUrl: null },
  { name: 'We Are the Champions – Queen', imageUrl: null },
  { name: "Don't Stop Me Now – Queen", imageUrl: null },
  { name: 'Somebody to Love – Queen', imageUrl: null },
  { name: 'Radio Ga Ga – Queen', imageUrl: null },
  { name: 'Killer Queen – Queen', imageUrl: null },
  { name: 'I Want to Break Free – Queen', imageUrl: null },
  { name: 'Another One Bites the Dust – Queen', imageUrl: null },
  { name: 'Under Pressure – Queen & Bowie', imageUrl: null },
  { name: 'Space Oddity – David Bowie', imageUrl: null },
  { name: 'Heroes – David Bowie', imageUrl: null },
  { name: 'Ziggy Stardust – David Bowie', imageUrl: null },
  { name: 'Life on Mars – David Bowie', imageUrl: null },
  { name: 'Changes – David Bowie', imageUrl: null },
  { name: "Let's Dance – David Bowie", imageUrl: null },
  { name: 'Rebel Rebel – David Bowie', imageUrl: null },
  { name: 'Golden Years – David Bowie', imageUrl: null },
  { name: 'Heroes (Full Version) – David Bowie', imageUrl: null },
  { name: 'Born in the USA – Springsteen', imageUrl: null },
  { name: 'Thunder Road – Bruce Springsteen', imageUrl: null },
  { name: 'The River – Bruce Springsteen', imageUrl: null },
  { name: 'Dancing in the Dark – Springsteen', imageUrl: null },
  { name: 'Darkness on the Edge of Town – BS', imageUrl: null },
  { name: 'Jungleland – Bruce Springsteen', imageUrl: null },
  { name: 'Badlands – Bruce Springsteen', imageUrl: null },
  { name: 'Atlantic City – Bruce Springsteen', imageUrl: null },
  { name: "I'm on Fire – Bruce Springsteen", imageUrl: null },
  { name: 'Hungry Heart – Bruce Springsteen', imageUrl: null },
  { name: 'Dream On – Aerosmith', imageUrl: null },
  { name: 'Walk This Way – Aerosmith', imageUrl: null },
  { name: 'Love in an Elevator – Aerosmith', imageUrl: null },
  { name: "I Don't Want to Miss a Thing – Aerosmith", imageUrl: null },
  { name: "Livin' on a Prayer – Bon Jovi", imageUrl: null },
  { name: 'Wanted Dead or Alive – Bon Jovi', imageUrl: null },
  { name: 'You Give Love a Bad Name – Bon Jovi', imageUrl: null },
  { name: 'Runaway – Bon Jovi', imageUrl: null },
  { name: "It's My Life – Bon Jovi", imageUrl: null },
  { name: 'Jump – Van Halen', imageUrl: null },
  { name: 'Eruption – Van Halen', imageUrl: null },
  { name: 'Panama – Van Halen', imageUrl: null },
  { name: 'Hot for Teacher – Van Halen', imageUrl: null },
  { name: 'Running with the Devil – Van Halen', imageUrl: null },
  { name: 'Highway to Hell – AC/DC', imageUrl: null },
  { name: 'Thunderstruck – AC/DC', imageUrl: null },
  { name: 'You Shook Me All Night Long – AC/DC', imageUrl: null },
  { name: 'Whole Lotta Rosie – AC/DC', imageUrl: null },
  { name: 'TNT – AC/DC', imageUrl: null },
  { name: 'Hells Bells – AC/DC', imageUrl: null },
  { name: 'Shoot to Thrill – AC/DC', imageUrl: null },
  { name: 'Enter Sandman – Metallica', imageUrl: null },
  { name: 'Master of Puppets – Metallica', imageUrl: null },
  { name: 'One – Metallica', imageUrl: null },
  { name: 'Nothing Else Matters – Metallica', imageUrl: null },
  { name: 'For Whom the Bell Tolls – Metallica', imageUrl: null },
  { name: 'Battery – Metallica', imageUrl: null },
  { name: 'Seek & Destroy – Metallica', imageUrl: null },
  { name: 'Fade to Black – Metallica', imageUrl: null },
  { name: 'Creep – Radiohead', imageUrl: null },
  { name: 'Karma Police – Radiohead', imageUrl: null },
  { name: 'Fake Plastic Trees – Radiohead', imageUrl: null },
  { name: 'High and Dry – Radiohead', imageUrl: null },
  { name: 'Paranoid Android – Radiohead', imageUrl: null },
  { name: 'Everything in Its Right Place – RH', imageUrl: null },
  { name: 'No Surprises – Radiohead', imageUrl: null },
  { name: 'Street Spirit – Radiohead', imageUrl: null },
  { name: 'In the Air Tonight – Phil Collins', imageUrl: null },
  { name: 'Sussudio – Phil Collins', imageUrl: null },
  { name: "You Can't Hurry Love – Phil Collins", imageUrl: null },
  { name: 'Invisible Touch – Genesis', imageUrl: null },
  { name: 'Land of Confusion – Genesis', imageUrl: null },
  { name: 'Sledgehammer – Peter Gabriel', imageUrl: null },
  { name: 'Solsbury Hill – Peter Gabriel', imageUrl: null },
  { name: 'In Your Eyes – Peter Gabriel', imageUrl: null },
  { name: 'Blood of Eden – Peter Gabriel', imageUrl: null },
  { name: 'With or Without You – U2', imageUrl: null },
  { name: 'Sunday Bloody Sunday – U2', imageUrl: null },
  { name: 'Where the Streets Have No Name – U2', imageUrl: null },
  { name: "I Still Haven't Found – U2", imageUrl: null },
  { name: 'One – U2', imageUrl: null },
  { name: 'Beautiful Day – U2', imageUrl: null },
  { name: 'Mysterious Ways – U2', imageUrl: null },
  { name: 'Pride (In the Name of Love) – U2', imageUrl: null },
  { name: 'Rattle and Hum – U2', imageUrl: null },
  { name: 'Elevation – U2', imageUrl: null },
  { name: 'Roxanne – The Police', imageUrl: null },
  { name: 'Every Breath You Take – The Police', imageUrl: null },
  { name: 'Message in a Bottle – The Police', imageUrl: null },
  { name: "Don't Stand So Close to Me – Police", imageUrl: null },
  { name: 'Walking on the Moon – The Police', imageUrl: null },
  { name: 'Every Little Thing She Does – Police', imageUrl: null },
  { name: 'Wrapped Around Your Finger – Police', imageUrl: null },
  { name: 'Driven to Tears – The Police', imageUrl: null },
  { name: 'Driven to Tears (Live) – The Police', imageUrl: null },
  { name: 'Spirits in the Material World – Police', imageUrl: null },
  { name: 'Dancing Queen – ABBA', imageUrl: null },
  { name: 'Waterloo – ABBA', imageUrl: null },
  { name: 'Fernando – ABBA', imageUrl: null },
  { name: 'The Winner Takes It All – ABBA', imageUrl: null },
  { name: 'Voulez-Vous – ABBA', imageUrl: null },
  { name: 'Gimme! Gimme! Gimme! – ABBA', imageUrl: null },
  { name: 'Money, Money, Money – ABBA', imageUrl: null },
  { name: 'Mamma Mia – ABBA', imageUrl: null },
  { name: 'Super Trouper – ABBA', imageUrl: null },
  { name: 'Does Your Mother Know – ABBA', imageUrl: null },
  { name: "Welcome to the Jungle – GN'R", imageUrl: null },
  { name: "Paradise City – Guns N' Roses", imageUrl: null },
  { name: "November Rain – Guns N' Roses", imageUrl: null },
  { name: "Patience – Guns N' Roses", imageUrl: null },
  { name: "Night Train – Guns N' Roses", imageUrl: null },
  { name: "Mr. Brownstone – Guns N' Roses", imageUrl: null },
  { name: "You Could Be Mine – GN'R", imageUrl: null },
  { name: "Estranged – Guns N' Roses", imageUrl: null },
  { name: "Civil War – Guns N' Roses", imageUrl: null },
  { name: "Rocket Queen – Guns N' Roses", imageUrl: null },
  { name: 'In Bloom – Nirvana', imageUrl: null },
  { name: 'Lithium – Nirvana', imageUrl: null },
  { name: 'Polly – Nirvana', imageUrl: null },
  { name: 'About a Girl – Nirvana', imageUrl: null },
  { name: 'Heart-Shaped Box – Nirvana', imageUrl: null },
  { name: 'All Apologies – Nirvana', imageUrl: null },
  { name: 'Man Who Sold the World – Nirvana', imageUrl: null },
  { name: 'The Man Who Sold the World – Bowie', imageUrl: null },
  { name: 'Where Did You Sleep Last Night – Nirvana', imageUrl: null },
  { name: 'Oh Well – Fleetwood Mac', imageUrl: null },
  { name: 'Go Your Own Way – Fleetwood Mac', imageUrl: null },
  { name: 'The Chain – Fleetwood Mac', imageUrl: null },
  { name: 'Dreams – Fleetwood Mac', imageUrl: null },
  { name: 'Gold Dust Woman – Fleetwood Mac', imageUrl: null },
  { name: 'Rhiannon – Fleetwood Mac', imageUrl: null },
  { name: 'Landslide – Fleetwood Mac', imageUrl: null },
  { name: 'Sara – Fleetwood Mac', imageUrl: null },
  { name: 'Big Love – Fleetwood Mac', imageUrl: null },
  { name: "Don't Stop – Fleetwood Mac", imageUrl: null },
  { name: 'Everlong – Foo Fighters', imageUrl: null },
  { name: 'Best of You – Foo Fighters', imageUrl: null },
  { name: 'Learn to Fly – Foo Fighters', imageUrl: null },
  { name: 'All My Life – Foo Fighters', imageUrl: null },
  { name: 'The Pretender – Foo Fighters', imageUrl: null },
  { name: 'Walk – Foo Fighters', imageUrl: null },
  { name: 'Rope – Foo Fighters', imageUrl: null },
  { name: 'These Days – Foo Fighters', imageUrl: null },
  { name: 'Times Like These – Foo Fighters', imageUrl: null },
  { name: 'Monkey Wrench – Foo Fighters', imageUrl: null },
  { name: 'Jeremy – Pearl Jam', imageUrl: null },
  { name: 'Alive – Pearl Jam', imageUrl: null },
  { name: 'Even Flow – Pearl Jam', imageUrl: null },
  { name: 'Better Man – Pearl Jam', imageUrl: null },
  { name: 'Black – Pearl Jam', imageUrl: null },
  { name: 'Given to Fly – Pearl Jam', imageUrl: null },
  { name: 'Last Kiss – Pearl Jam', imageUrl: null },
  { name: 'Yellow Ledbetter – Pearl Jam', imageUrl: null },
  { name: 'Elderly Woman – Pearl Jam', imageUrl: null },
  { name: 'Daughter – Pearl Jam', imageUrl: null },
  { name: 'Black Hole Sun – Soundgarden', imageUrl: null },
  { name: 'Spoonman – Soundgarden', imageUrl: null },
  { name: 'Fell on Black Days – Soundgarden', imageUrl: null },
  { name: 'Superunknown – Soundgarden', imageUrl: null },
  { name: 'Like Suicide – Soundgarden', imageUrl: null },
  { name: 'Burden in My Hand – Soundgarden', imageUrl: null },
  { name: 'Show Me How to Live – Audioslave', imageUrl: null },
  { name: 'Like a Stone – Audioslave', imageUrl: null },
  { name: 'Be Yourself – Audioslave', imageUrl: null },
  { name: 'Cochise – Audioslave', imageUrl: null },
  { name: 'Man in the Box – Alice in Chains', imageUrl: null },
  { name: 'Rooster – Alice in Chains', imageUrl: null },
  { name: 'Would? – Alice in Chains', imageUrl: null },
  { name: 'Down in a Hole – Alice in Chains', imageUrl: null },
  { name: 'Them Bones – Alice in Chains', imageUrl: null },
  { name: 'Angry Chair – Alice in Chains', imageUrl: null },
  { name: 'Blow Up the Outside World – SG', imageUrl: null },
  { name: 'Fell on Black Days (Live) – SG', imageUrl: null },
  { name: 'Just – Radiohead', imageUrl: null },
  { name: 'Fake Plastic Trees (Acoustic) – RH', imageUrl: null },
  { name: 'Where Is My Mind? – Pixies', imageUrl: null },
  { name: 'Here Comes Your Man – Pixies', imageUrl: null },
  { name: 'Gigantic – Pixies', imageUrl: null },
  { name: 'Debaser – Pixies', imageUrl: null },
  { name: 'Gouge Away – Pixies', imageUrl: null },
  { name: 'Monkey Gone to Heaven – Pixies', imageUrl: null },
  { name: 'Caribou – Pixies', imageUrl: null },
  { name: 'Hey – Pixies', imageUrl: null },
  { name: 'Bone Machine – Pixies', imageUrl: null },
  { name: 'Wave of Mutilation – Pixies', imageUrl: null },
  { name: 'The One I Love – R.E.M.', imageUrl: null },
  { name: 'Losing My Religion – R.E.M.', imageUrl: null },
  { name: 'Everybody Hurts – R.E.M.', imageUrl: null },
  { name: 'Man on the Moon – R.E.M.', imageUrl: null },
  { name: 'Shiny Happy People – R.E.M.', imageUrl: null },
  { name: 'Orange Crush – R.E.M.', imageUrl: null },
  { name: 'Drive – R.E.M.', imageUrl: null },
  { name: "What's the Frequency, Kenneth – REM", imageUrl: null },
  { name: 'Country Feedback – R.E.M.', imageUrl: null },
  { name: 'Nightswimming – R.E.M.', imageUrl: null },
  { name: 'Alive – Collective Soul', imageUrl: null },
  { name: 'Shimmer – Fuel', imageUrl: null },
  { name: 'Lightning Crashes – Live', imageUrl: null },
  { name: 'Selling the Drama – Live', imageUrl: null },
  { name: 'I Alone – Live', imageUrl: null },
  { name: '100% – Sonic Youth', imageUrl: null },
  { name: 'Teen Age Riot – Sonic Youth', imageUrl: null },
  { name: 'Superstar – Sonic Youth', imageUrl: null },
  { name: 'Dirty Boots – Sonic Youth', imageUrl: null },
  { name: 'Kool Thing – Sonic Youth', imageUrl: null },
  { name: "Say It Ain't So – Weezer", imageUrl: null },
  { name: 'Buddy Holly – Weezer', imageUrl: null },
  { name: 'Undone (The Sweater Song) – Weezer', imageUrl: null },
  { name: 'El Scorcho – Weezer', imageUrl: null },
  { name: 'Island in the Sun – Weezer', imageUrl: null },
  { name: 'Perfect Situation – Weezer', imageUrl: null },
  { name: 'Beverly Hills – Weezer', imageUrl: null },
  { name: 'Hash Pipe – Weezer', imageUrl: null },
  { name: 'Pinkerton (album) – Weezer', imageUrl: null },
  { name: "Keep Fishin' – Weezer", imageUrl: null },
  { name: 'Song 2 – Blur', imageUrl: null },
  { name: 'Girls & Boys – Blur', imageUrl: null },
  { name: 'Coffee & TV – Blur', imageUrl: null },
  { name: 'Country House – Blur', imageUrl: null },
  { name: 'Beetlebum – Blur', imageUrl: null },
  { name: 'Tender – Blur', imageUrl: null },
  { name: 'The Universal – Blur', imageUrl: null },
  { name: 'Parklife – Blur', imageUrl: null },
  { name: 'This Is a Low – Blur', imageUrl: null },
  { name: 'End of a Century – Blur', imageUrl: null },
  { name: 'Champagne Supernova – Oasis', imageUrl: null },
  { name: 'Wonderwall – Oasis', imageUrl: null },
  { name: "Don't Look Back in Anger – Oasis", imageUrl: null },
  { name: 'Live Forever – Oasis', imageUrl: null },
  { name: 'Supersonic – Oasis', imageUrl: null },
  { name: 'Some Might Say – Oasis', imageUrl: null },
  { name: 'Slide Away – Oasis', imageUrl: null },
  { name: 'Morning Glory – Oasis', imageUrl: null },
  { name: "She's Electric – Oasis", imageUrl: null },
  { name: 'Half the World Away – Oasis', imageUrl: null },
  { name: 'Feeling Good – Muse', imageUrl: null },
  { name: 'Supermassive Black Hole – Muse', imageUrl: null },
  { name: 'Uprising – Muse', imageUrl: null },
  { name: 'Madness – Muse', imageUrl: null },
  { name: 'Time Is Running Out – Muse', imageUrl: null },
  { name: 'Starlight – Muse', imageUrl: null },
  { name: 'Neutron Star Collision – Muse', imageUrl: null },
  { name: 'Knights of Cydonia – Muse', imageUrl: null },
  { name: 'Hysteria – Muse', imageUrl: null },
  { name: 'Undisclosed Desires – Muse', imageUrl: null },
  { name: 'Psycho – Muse', imageUrl: null },
  { name: 'The Handler – Muse', imageUrl: null },
  { name: 'Pressure – Muse', imageUrl: null },
  { name: 'Algorithm – Muse', imageUrl: null },
  { name: 'Reapers – Muse', imageUrl: null },
  { name: 'Dig Down – Muse', imageUrl: null },
  { name: 'Break It to Me – Muse', imageUrl: null },
  { name: 'The Dark Side – Muse', imageUrl: null },
  { name: 'Resistance – Muse', imageUrl: null },
  { name: 'Unintended – Muse', imageUrl: null },
  { name: 'City of Delusion – Muse', imageUrl: null },
  { name: 'Exogenesis Symphony Pt 1 – Muse', imageUrl: null },
  { name: 'Stockholm Syndrome – Muse', imageUrl: null },
  { name: 'Muscle Museum – Muse', imageUrl: null },
  { name: 'Showbiz – Muse', imageUrl: null },
  { name: 'Sunburn – Muse', imageUrl: null },
  { name: 'Uno – Muse', imageUrl: null },
  { name: 'Cave – Muse', imageUrl: null },
  { name: 'Spiral Static – Muse', imageUrl: null },
  { name: 'Map of the Problematique – Muse', imageUrl: null },
  { name: 'Invincible – Muse', imageUrl: null },
  { name: "Soldier's Poem – Muse", imageUrl: null },
  { name: 'Assassin – Muse', imageUrl: null },
  { name: 'Apocalypse Please – Muse', imageUrl: null },
  { name: 'Butterflies and Hurricanes – Muse', imageUrl: null },
  { name: 'New Born – Muse', imageUrl: null },
  { name: 'Bliss – Muse', imageUrl: null },
  { name: 'Plug In Baby – Muse', imageUrl: null },
  { name: 'Micro Cuts – Muse', imageUrl: null },
  { name: 'Citizen Erased – Muse', imageUrl: null },
  { name: 'Origin of Symmetry (album) – Muse', imageUrl: null },
  { name: 'Absolution (album) – Muse', imageUrl: null },
  { name: 'Black Holes and Revelations – Muse', imageUrl: null },
  { name: 'The Resistance (album) – Muse', imageUrl: null },
  { name: 'The 2nd Law – Muse', imageUrl: null },
  { name: 'Drones – Muse', imageUrl: null },
  { name: 'Simulation Theory – Muse', imageUrl: null },
  { name: 'Will of the People – Muse', imageUrl: null },
  { name: 'Compliance – Muse', imageUrl: null },
  { name: 'Liberation – Muse', imageUrl: null },
  { name: 'Verona – Muse', imageUrl: null },
  { name: 'Kill or Be Killed – Muse', imageUrl: null },
  { name: "Won't Stand Down – Muse", imageUrl: null },
  { name: 'Euphoria – Muse', imageUrl: null },
  { name: 'Ghosts (How Can I Move On) – Muse', imageUrl: null },
  { name: 'Pride and Prejudice – Muse', imageUrl: null },
  { name: 'Isolated System – Muse', imageUrl: null },
  { name: 'Big Freeze – Muse', imageUrl: null },
  { name: 'Save Me – Muse', imageUrl: null },
  { name: 'Follow Me – Muse', imageUrl: null },
  { name: 'Animals – Muse', imageUrl: null },
  { name: 'Explorers – Muse', imageUrl: null },
  { name: 'Prelude – Muse', imageUrl: null },
  { name: 'Panic Station – Muse', imageUrl: null },
  { name: 'Supremacy – Muse', imageUrl: null },
  { name: 'Madness (Radio Edit) – Muse', imageUrl: null },
  { name: 'Back to Black – Amy Winehouse', imageUrl: null },
  { name: 'Rehab – Amy Winehouse', imageUrl: null },
  { name: 'Valerie – Amy Winehouse', imageUrl: null },
  { name: 'Tears Dry on Their Own – Amy W.', imageUrl: null },
  { name: 'Love Is a Losing Game – Amy W.', imageUrl: null },
  { name: 'Me and Mr. Jones – Amy Winehouse', imageUrl: null },
  { name: 'Some Unholy War – Amy Winehouse', imageUrl: null },
  { name: 'Wake Up Alone – Amy Winehouse', imageUrl: null },
  { name: 'Just Friends – Amy Winehouse', imageUrl: null },
  { name: "You Know I'm No Good – Amy W.", imageUrl: null },
  { name: 'Seven Nation Army – White Stripes', imageUrl: null },
  { name: 'Fell in Love with a Girl – White Stripes', imageUrl: null },
  { name: 'Icky Thump – The White Stripes', imageUrl: null },
  { name: 'Ball and Biscuit – The White Stripes', imageUrl: null },
  { name: 'Dead Leaves – The White Stripes', imageUrl: null },
  { name: 'Hotel Yorba – The White Stripes', imageUrl: null },
  { name: 'Elephant (album) – White Stripes', imageUrl: null },
  { name: 'White Blood Cells (album) – WS', imageUrl: null },
  { name: 'De Stijl (album) – White Stripes', imageUrl: null },
  { name: 'The White Stripes (debut) – WS', imageUrl: null },
  { name: 'Are You Gonna Be My Girl – Jet', imageUrl: null },
  { name: 'Last Nite – The Strokes', imageUrl: null },
  { name: 'Reptilia – The Strokes', imageUrl: null },
  { name: 'Someday – The Strokes', imageUrl: null },
  { name: 'Is This It – The Strokes', imageUrl: null },
  { name: 'Hard to Explain – The Strokes', imageUrl: null },
  { name: '12:51 – The Strokes', imageUrl: null },
  { name: 'Automatic Stop – The Strokes', imageUrl: null },
  { name: 'Juicebox – The Strokes', imageUrl: null },
  { name: 'New York City Cops – The Strokes', imageUrl: null },
  { name: 'Human – The Killers', imageUrl: null },
  { name: 'Mr. Brightside – The Killers', imageUrl: null },
  { name: 'Somebody Told Me – The Killers', imageUrl: null },
  { name: "All These Things That I've Done – TK", imageUrl: null },
  { name: 'When You Were Young – The Killers', imageUrl: null },
  { name: 'Smile Like You Mean It – TK', imageUrl: null },
  { name: 'Jenny Was a Friend of Mine – TK', imageUrl: null },
  { name: "Andy, You're a Star – The Killers", imageUrl: null },
  { name: 'Midnight Show – The Killers', imageUrl: null },
  { name: 'Believe Me Natalie – The Killers', imageUrl: null },
  { name: 'In My Place – Coldplay', imageUrl: null },
  { name: 'The Scientist – Coldplay', imageUrl: null },
  { name: 'Yellow – Coldplay', imageUrl: null },
  { name: 'Clocks – Coldplay', imageUrl: null },
  { name: 'Speed of Sound – Coldplay', imageUrl: null },
  { name: 'Fix You – Coldplay', imageUrl: null },
  { name: 'Shiver – Coldplay', imageUrl: null },
  { name: 'Trouble – Coldplay', imageUrl: null },
  { name: 'Amsterdam – Coldplay', imageUrl: null },
  { name: 'Politik – Coldplay', imageUrl: null },
  { name: 'The Hardest Part – Coldplay', imageUrl: null },
  { name: 'Viva la Vida – Coldplay', imageUrl: null },
  { name: 'Lost! – Coldplay', imageUrl: null },
  { name: 'Lovers in Japan – Coldplay', imageUrl: null },
  { name: 'Death and All His Friends – Coldplay', imageUrl: null },
  { name: 'Every Teardrop Is a Waterfall – CP', imageUrl: null },
  { name: 'Paradise – Coldplay', imageUrl: null },
  { name: 'Charlie Brown – Coldplay', imageUrl: null },
  { name: 'Princess of China – Coldplay & RiRi', imageUrl: null },
  { name: 'Magic – Coldplay', imageUrl: null },
  { name: 'A Sky Full of Stars – Coldplay', imageUrl: null },
  { name: 'Midnight – Coldplay', imageUrl: null },
  { name: 'A Head Full of Dreams – Coldplay', imageUrl: null },
  { name: 'Hymn for the Weekend – Coldplay', imageUrl: null },
  { name: 'Adventure of a Lifetime – Coldplay', imageUrl: null },
  { name: 'Something Just Like This – Coldplay', imageUrl: null },
  { name: 'My Universe – Coldplay & BTS', imageUrl: null },
  { name: 'Higher Power – Coldplay', imageUrl: null },
  { name: 'Music of the Spheres – Coldplay', imageUrl: null },
  { name: 'An MC Escher Drawing – Coldplay', imageUrl: null },
  { name: 'Coloratura – Coldplay', imageUrl: null },
  { name: 'People of the Pride – Coldplay', imageUrl: null },
  { name: 'Let Somebody Go – Coldplay', imageUrl: null },
  { name: 'Human Heart – Coldplay', imageUrl: null },
  { name: 'Infinity Sign – Coldplay', imageUrl: null },
  { name: 'Running With Wolves – Coldplay', imageUrl: null },
  { name: 'Biutyful – Coldplay', imageUrl: null },
  { name: 'Humankind – Coldplay', imageUrl: null },
  { name: 'We Pray – Coldplay', imageUrl: null },
  { name: 'One World – Coldplay', imageUrl: null },
  { name: 'feelslikeimfallinginlove – Coldplay', imageUrl: null },
  { name: 'Good Feelings – Coldplay', imageUrl: null },
  { name: 'Moon Music – Coldplay', imageUrl: null },
  { name: 'Family Portrait – Coldplay', imageUrl: null },
  { name: 'We Ask for No Sorrow – Coldplay', imageUrl: null }
]
